var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dg-modal',{attrs:{"size":"sm","show":_vm.show,"options":{ ..._vm.modalOptions, loading: _vm.deleting }},on:{"submit":_vm.deleteTodoItem,"close":function($event){return _vm.$emit('close')}}},[_c('p',[_vm._v(_vm._s(_vm.$t("todos.confirm_delete.description")))])])
}
var staticRenderFns = []

export { render, staticRenderFns }